import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Badge } from '@/components/ui/badge'
import type { CotizacionListItem } from '../types'

interface CotizacionDetailModalProps {
  cotizacion: CotizacionListItem | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

function Campo({ label, valor }: { label: string; valor: React.ReactNode }) {
  return (
    <div>
      <p className="text-sm text-muted-foreground">{label}</p>
      <p className="font-medium">{valor || '—'}</p>
    </div>
  )
}

export function CotizacionDetailModal({ cotizacion, open, onOpenChange }: CotizacionDetailModalProps) {
  if (!cotizacion) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Detalle de Cotización #{cotizacion.id}</DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          <div>
            <h4 className="text-sm font-semibold text-muted-foreground mb-3">Contacto</h4>
            <div className="grid grid-cols-2 gap-4">
              <Campo label="Nombre" valor={cotizacion.nombre} />
              <Campo label="Email" valor={cotizacion.email} />
              <Campo label="Empresa" valor={cotizacion.empresa} />
              <Campo label="Laboratorio" valor={cotizacion.laboratorio} />
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-muted-foreground mb-3">Volúmenes</h4>
            <div className="grid grid-cols-2 gap-4">
              <Campo label="Total Envíos" valor={cotizacion.total_envios.toLocaleString('es-EC')} />
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-muted-foreground mb-3">Precio y Estado</h4>
            <div className="grid grid-cols-2 gap-4">
              <Campo
                label="Precio Total"
                valor={`$${cotizacion.precio_total.toLocaleString('es-EC', { minimumFractionDigits: 2 })}`}
              />
              <Campo
                label="Estado"
                valor={
                  <Badge className={cotizacion.atendida
                    ? 'badge-gradient hover:opacity-90'
                    : 'bg-transparent border border-amber-500 text-amber-500 hover:bg-transparent hover:text-amber-500'
                  }>
                    {cotizacion.atendida ? 'Atendida' : 'Pendiente'}
                  </Badge>
                }
              />
              <Campo
                label="Fecha"
                valor={new Date(cotizacion.fecha_creacion).toLocaleString('es-EC')}
              />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
